// extracted by mini-css-extract-plugin
export default {"iconBox":"Ua4GtepF4DFV9bs4X4gs"};